import { apiClass } from '@/base/class/api.class'
import { ENDPOINTS } from '@/base/const/endpoints.const'
import { Raven } from 'vue-raven'

const state = {
  loading: false,
  data: null,
  error: {
    invalidFields: null
  }
}

const mutations = {
  SET_RESULT_LOADING (state, value) {
    state.loading = value
  },
  SET_RESULT_DATA (state, data) {
    state.data = data
  },
  SET_RESULT_ERROR_INVALID_FIELDS (state, data) {
    state.error.invalidFields = data
  }
}

const actions = {
  getResultTrx ({ commit, state, dispatch }, { apiToken }) {
    commit('SET_RESULT_LOADING', true)
    const url = `${ENDPOINTS.result}?apiToken=${apiToken}`
    return apiClass.get(url)
      .then(response => {
        const data = response.body.data
        commit('SET_RESULT_DATA', data)
        dispatch('setPaymentLanguage', data)
        return Promise.resolve(response)
      })
      .finally(() => {
        commit('SET_RESULT_LOADING', false)
      })
      .catch(error => {
        if (error.body.invalidFields) {
          commit('SET_RESULT_ERROR_INVALID_FIELDS', error.body.invalidFields)
        }
        Raven.captureMessage('result.js getResultTrx Method response error', {
          extra: error
        })
        return Promise.reject(error)
      })
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
